const es = {
    // Common
    'Close': 'Cerca',
    'From': 'Desde',
    'To': 'A',
    'Distance': 'Distancia',
    'Estimated time': 'Hora Prevista',
    'Level': 'Nivel',
    'Search by name, category, building...': 'Busca por nombre, categoría, edificio...',
    'Show legend': 'Mostrar leyenda',
    'Ask with AI': 'Preguntar con IA',
    'Nothing was found': 'No se encontró nada',
    'd': 'd',
    'h': 'h',
    'min': 'mín',
    'Walk': 'Caminar',
    'Bike': 'Bicicleta',
    'Transit': 'Transporte público',
    'Drive': 'Conducir',
    'Start wayfinding': 'Iniciar la navegación',
    // Location Details
    'Read full description': 'Leer descripción completa',
    // Locations List
    'Locations': 'Ubicaciones',
    'Directions not available': 'Direcciones no disponibles',
    'Start directions': 'Comenzar direcciones',
    // Route instructions
    'Previous': 'Previo',
    'Next': 'Próximo',
    'StepYofX': 'Paso {{activeStep}} de {{totalSteps}}',
    // Route Instructions Step
    'You have arrived': 'Has llegado',
    'Leave': 'Dejar',
    'Park': 'Estacionar',
    'at': 'en',
    'Building': 'Edificio',
    'Venue': 'Evento',
    'Take staircase to level': 'Tome la escaleras al nivel',
    'Take the ladder to level': 'Tome la escalera al nivel',
    'Take elevator to level': 'Tome el ascensor hasta el nivel',
    'Take escalator to level': 'Tome la escalera mecánica al nivel',
    'Take wheelchair lift to level': 'Tome el elevador de sillas de ruedas hasta el nivel',
    'Take wheelchair ramp to level': 'Tome la rampa para sillas de ruedas hasta nivelar',
    'Exit': 'Salida',
    'Enter': 'Ingresar',
    'stops': 'paradas',
    'and continue': 'y continuar',
    'Continue straight ahead': 'Continúe recto',
    'Go left': 'Ve a la izquierda',
    'Go sharp left': 'Vaya bruscamente a la izquierda',
    'Go slight left': 'Vaya ligeramente a la izquierda',
    'Go right': 'Ve a la derecha',
    'Go sharp right': 'Vaya bruscamente a la derecha',
    'Go slight right': 'Vaya ligeramente a la derecha',
    'Turn around': 'Giro de vuelta',
    // Wayfinding component
    'Switch': 'Cambiar',
    'Avoid stairs and escalators': 'Evitar escaleras y escaleras mecánicas',
    'Include bus transportation': 'Incluir transporte en autobús',
    'No route found': 'No se encontró ninguna ruta',
    'My position': 'Mi posición',
    'Go!': '¡Ir!',
    'Directions': 'Instrucciones',
    'Choose departure': 'Elige la salida',
    'Choose destination': 'Elige destino',
    // Venue selector
    'Venues': 'Lugares',
    'Select venue': 'Seleccionar lugar',
    'Current': 'Actual',
    // QR code dialog
    'Scan QR code': 'Escanear código QR',
    'Scan the QR code to see the route on your phone': 'Escanea el código QR para ver la ruta en tu teléfono',
    'Done': 'Finalizado',
    // Directions
    'Cancel route': 'Cancelar ruta',
    'Finish route': 'Finalizar ruta',
    // Share location link
    'Share': 'Compartir',
    'Copy link': 'Copiar link',
    'QR Code': 'Código QR',
    // Opening Hours
    'Open': 'Abierto',
    'Closed': 'Cerrado',
    'Expand opening hours': 'Expandir horario de apertura',
    'Collapse opening hours': 'Contraer horario de apertura',
    // View Selector
    'Go to view': 'Ver ubicación',
    'Close view selector': 'Cerrar selector de vista',
    // Language Selector
    'Select language': 'Seleccionar idioma',
    // Accessibility
    'Increase text size to 200%': 'Aumentar el tamaño del texto al 200%',
    'Decrease text size to 100%': 'Reducir el tamaño del texto al 100%',
    // Map Controls
    'Zoom in': 'Acercar',
    'Zoom out': 'Alejar',
    // Ask with AI - Usage Consent
    'Usage consent title': 'Ask with AI - Consentimiento de uso',
    'Usage consent message': 'Ask with AI te ayuda a encontrar lugares y navegar por este recinto utilizando Inteligencia Artificial (IA). Aunque nos esforzamos por ser precisos, la IA a veces puede cometer errores. Por favor, verifica los detalles importantes antes de ponerte en camino.',
    'Usage consent accept': 'Entendido',
    'Usage consent decline': 'Rechazar',
    'AI disclaimer': 'Ask with AI puede cometer errores. Verifica los detalles importantes antes de ponerte en camino.',
    // Location Consent
    'Location consent message': 'Para ofrecer indicaciones personalizadas y ayudarte a descubrir lo que hay cerca, Ask with AI necesita acceder a tu ubicación. El chat seguirá funcionando sin conocer tu ubicación, pero tendrás que especificar un punto de partida.',
    'Location consent accept': 'Permitir',
    'Location consent decline': 'Rechazar',
};

export default es;
